import {Injectable, NgZone} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {iDelivery} from "../model/CartModel";
import {Facet, FacetValue, SelectedFacet, SelectedElement} from "../model/ListingModel";
declare const listingPage;

@Injectable({
  providedIn: 'root',
})
export class ListingService {
  private listingURL = environment.links.listing.response;
  private facets = new BehaviorSubject<(Facet)[]>([]);
  private selected = new BehaviorSubject<(SelectedFacet)[]>([]);
  private facetToSelected = {};
  public facetsList = this.facets.asObservable();
  public selectedList = this.selected.asObservable();

  constructor(
    private http: HttpClient,
    private ngZone: NgZone
  ) {
    window['angularListingServiceReference'] = {
      component: this,
      zone: this.ngZone,
      pushListingData: (_listing) => this.pushListingData(_listing)
    };
  };

  pushListingData(_listing) {
    const {facets, selected} = _listing;

    this.facets.next(facets);
    this.selected.next(selected);
    this.isSelectedFacets(facets);
  }

  isSelectedFacets(_facets) {
    const facets = _facets;

    facets.forEach((facet) => {
      const selectedFacets =
        facet.values.filter((el: FacetValue) => el.selected === true)
        .map((el) => ({checked: el.selected, keyName:`${facet.code}-${el.code}`, key: facet.webname, value:el.code}));

      if(!selectedFacets.length) return;

      selectedFacets.forEach((selected: SelectedElement) =>
        this.facetToSelected[`${selected.keyName}`] = {key: selected.key, value: selected.value})
    });
  }

  toggleFacetToSelected(_facet: SelectedElement, toRemove = false) {
    const {keyName, key, value, checked} = _facet;

    if(toRemove) {
      delete this.facetToSelected[`${keyName}`];
      this.filterProducts();
      return;
    }

    this.facetToSelected.hasOwnProperty(`${keyName}`) || !checked ?
      delete this.facetToSelected[`${keyName}`] : this.facetToSelected[`${keyName}`] = {key, value};

    this.filterProducts();
  }

  toggleFramesSize(_facets) {
    this.facetToSelected = {...this.facetToSelected, ..._facets};
    this.filterProducts();
  }

  removeFrameSize(_facet) {
    const toRemove = Object.keys(this.facetToSelected).filter(key => key.startsWith(_facet));

    if(toRemove.length) toRemove.forEach(facet => delete this.facetToSelected[facet]);
  }

  filterProducts(bResetSearch = true) {
    const filters = Object.keys(this.facetToSelected).length ? Object.values(this.facetToSelected) : [];

    listingPage.searchProductsSecondBigger(bResetSearch, filters);
  }

  resetFilters() {
    this.facetToSelected = {};
    listingPage.searchProductsSecondBigger(true, []);
  }
}
